module.exports = __webpack_public_path__ + "img/33.ccc91bd0.png";